// extracted by mini-css-extract-plugin
export default {"header":"Logout_header__3M6sN","container":"Logout_container__DEvcb","text":"Logout_text__d0Pr1"};